import { useEffect } from 'react';
import { FlexGrid, Button, Typography, useDialog, useThemeProvider, Card, Skeleton, Separator } from '@albo-ui/core'
import { AfbAdminCardsProps, CouponsProps } from './types';
import { useAfbCardsTable } from './hooks/useAfbCardsTable';
import DataTable from 'react-data-table-component';
import { customStyles2 } from '../../../util/TableStyles'
import { noDataComponent, searchTypesAfb } from '../../../util/DataObject'
import { paginationComponentOptions } from '../../../util/i18n-es';
import { Search, SettingsSuggest, Refresh } from '@mui/icons-material';
import { IconButton, TextField, Select, MenuItem } from '@mui/material';
import { UpdateCard } from '../../modals/afb-cards-admin/UpdateCard';
import { InfoCard } from '../../modals/afb-cards-admin/InfoCard';
import { FilterCards } from '../../modals/afb-cards-admin/FilterCards';
import CustomPagination from '../../elements/CustomPagination';

export const AfbAdminCards = ({ changeAlert, changeLoader, sectionData, payload }: AfbAdminCardsProps) => {
    const { theme } = useThemeProvider();
    const dialogProps = useDialog();
    const infoProps = useDialog();
    const filterDialog = useDialog();
    const onOpenDialog = () => { dialogProps.openDialog() }
    const onOpenInfoDialog = () => { infoProps.openDialog() }

    const { columns, data, loading: loadingTable, loading: loadingUpdate, searchData, disabledSearch, rowsPerPage, totalRows, page, dialogData, search,
         onHandleUpdate, saveData, onHandleChange, onHandleSearch, onSetTypeSearch, handleChangeRowsPerPage, changePage, onSetSearch, downloadReport, onHandleReset } = useAfbCardsTable(changeAlert, onOpenDialog, onOpenInfoDialog)
    
    // Update --------
    const onUpdateData = async (data: CouponsProps) => {
        dialogProps.onClose()
        onHandleUpdate(data, dialogData.type)
    }
    const onCloseDialog = () => {
        dialogProps.onClose()
    }

    // Info --------
    const onCloseInfoDialog = () => {
        infoProps.onClose()
    }
    
    // Filter ---------------
    const onSearchByFilter = async (data: CouponsProps) => {
        filterDialog.onClose()
        onHandleSearch(data)
    }
    const onCloseFilters = () => {
        filterDialog.onClose()
    }
    const onOpenFilters = () => {
        filterDialog.openDialog()
    }

    useEffect(() => {
        changeLoader(loadingTable)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable])
    useEffect(() => {
        changeLoader(loadingUpdate)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingUpdate])

    useEffect(() => {
        onSetSearch(payload)
        saveData(sectionData)
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Card padding={5} flexDirection='column' fullWidth fullHeight alignItems='stretch' justifyContent='space-between' style={{ borderColor: theme.colors.manatee, margin: 3 }}> 
            <FlexGrid container fullWidth justify='space-between' style={{ display: 'flex', marginBottom: 25 }}>
                <FlexGrid item>
                    <Typography variant='h2' style={{display: 'inline-flex', alignItems: 'center', fontSize: '1.2rem'}}>
                        <SettingsSuggest sx={{ marginRight: 1 }}/> Reporte de tarjetas para dispersar nómina
					</Typography>
                </FlexGrid>
                <FlexGrid item container spacing={2} style={{width: '30%', justifyContent: 'end'}}>
                    <Button buttonType='secondary' size='normal' onClick={onOpenFilters}>Filtrar</Button>
                    <Button buttonType='primary' size='normal' onClick={downloadReport}>Descargar</Button>
                </FlexGrid>
            </FlexGrid>

            <FlexGrid container spacing={2} style={{width: '45%', marginBottom: 25}}>
                <Select value={Object.keys(search)[0] || '-1'} onChange={onSetTypeSearch.bind(this)} size='small' color='secondary'>
                    <MenuItem value={'-1'} disabled>Seleccione</MenuItem>
                    {searchTypesAfb.map((item) => {
                        return <MenuItem key={item.key} value={item.key}>{item.label}</MenuItem>
                    })}
                </Select>
                <TextField label={'Buscar por Razón Social o RFC'} value={search[Object.keys(search)[0]] || ""} style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }} onPaste={onHandleChange.bind(this)} onChange={onHandleChange.bind(this)} color='secondary' fullWidth
					InputProps={{endAdornment: (<IconButton disabled={disabledSearch} onClick={() => onHandleSearch(null, false, true)} ><Search/></IconButton>)}}
                />
                <IconButton onClick={onHandleReset.bind(this)} sx={{padding: "0 !important"}} ><Refresh sx={{padding: "13px", borderRadius: 2, boxSizing: "content-box", color: "white", backgroundColor: "#8bc179" }}/></IconButton>
            </FlexGrid>

            { data.length === 0 && <Separator orientation='horizontal' style={{minHeight: 4, maxHeight: 4}} />}
            <FlexGrid container style={{margin: '25px 0'}}>
                {
                    loadingTable ?
                        <Skeleton width='100%' height='100px' />
                        :
                        <FlexGrid fullWidth>
                            <DataTable
                                columns={columns}
                                data={data}
                                customStyles={customStyles2}
                                noDataComponent={noDataComponent}
                                progressPending={loadingTable}
                                paginationComponentOptions={paginationComponentOptions}
                            />
                            <CustomPagination 
                                rows={totalRows}
                                page={page - 1}
                                rowsPerPage={rowsPerPage}
                                handleChangePage={changePage}
                                handleChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        </FlexGrid>

                }
            </FlexGrid>
            <UpdateCard 
                data={dialogData.info}
                type={dialogData.type}
                title={dialogData.text["title"]}
                message={dialogData.text["message"]}
                open={dialogProps.open}
                onClose={onCloseDialog}
                onConfirm={onUpdateData.bind(this)}
            />
            <InfoCard 
                data={dialogData.info}
                type={dialogData.type}
                title={dialogData.text["title"]}
                message={dialogData.text["message"]}
                open={infoProps.open}
                onClose={onCloseInfoDialog}
            />
            <FilterCards
                title={'Filtrar por'}
                open={filterDialog.open}
                data={searchData}
                onClose={onCloseFilters}
                onConfirm={onSearchByFilter.bind(this)}
            />
        </Card>
    )
}

